import {getRandomColor} from "../../utils/GetRandomColor";
export default function Painting({title, medium, relativeImagePath}) {
    const imageStyle = {
        border: `5px solid ${getRandomColor()}`,
    };
    
    const headingStyle = {
        margin: 0,
    };
    
  return (
    <div className="painting-item mb-4">
      <h3 style={headingStyle}>{title}</h3>
      <p><em>{medium}</em></p>
      <img src={relativeImagePath} alt={title} className="img-fluid" style={imageStyle} />
    </div>
  );
}